import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  buttonContainer: {
    display: 'flex',
    marginTop: spacing(10),
    '& > *': {
      marginRight: spacing(3),
    },
  },
  root: {
    marginTop: spacing(6),
  },
  sidebarTitle: {
    marginBottom: spacing(1) + 4,
  },
  message: {
    marginBottom: spacing(6),
  },
});

export default styles;
